<template>
  <div id="Add_country" class="xv_modal">
    <div class="modal_title">
      <div>
        <span>New country</span>
      </div>
      <div>
        <button class="modal_close" @click="close_add_country()">
          <span class="mdi mdi-close"></span>
        </button>
      </div>
    </div>
    <div class="modal_content">
      <div class="row">
        <div class="col-12">
          <label>Country</label>
          <input type="text" placeholder />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label>States</label>
          <input type="text" placeholder />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label>Cities</label>
          <input type="text" placeholder />
        </div>
      </div>
    </div>
    <div class="modal_footer">
      <button class="sec_btn m_r" @click="close_add_country()">Cancel</button>
      <button class="main_btn">Add</button>
    </div>
  </div>
</template>

<script>
// import employeePolicies from "./employee_policies/employee_policies.vue"

export default {
  name: "Add_country",
  components: {
    // employeePolicies,visitorPolicies,healthDeclarations,securityPartners,company,account
  },
  data() {
    return {};
  },
  methods: {
    close_add_country: function() {
      this.$modal.hide("add_country");
    }
  }
};
</script>
